document.addEventListener('DOMContentLoaded', function () {
  var panel = document.querySelector('[data-fam-filter-panel]');
  var toggle = document.querySelector('[data-fam-filter-toggle]');
  var closeBtn = document.querySelector('[data-fam-filter-close]');
  var backdrop = document.querySelector('[data-fam-filter-backdrop]');
  var isMobile = window.matchMedia('(max-width: 900px)').matches;

  if (isMobile && panel) {
    panel.querySelectorAll('details.fam-filter-accordion').forEach(function (details) {
      details.removeAttribute('open');
    });
  }

  if (panel && toggle) {
    function openPanel() {
      panel.classList.add('fam-open');
      if (backdrop) backdrop.classList.add('fam-open');
      document.body.style.overflow = 'hidden';
    }
    function closePanel() {
      panel.classList.remove('fam-open');
      if (backdrop) backdrop.classList.remove('fam-open');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', openPanel);
    if (closeBtn) closeBtn.addEventListener('click', closePanel);
    if (backdrop) backdrop.addEventListener('click', closePanel);
  }

  var form = document.getElementById('FamFacetFiltersForm');

  document.querySelectorAll('[data-fam-price-slider]').forEach(function (container) {
    var rangeMin = container.querySelector('[data-fam-range-min]');
    var rangeMax = container.querySelector('[data-fam-range-max]');
    var fill = container.querySelector('[data-fam-fill]');
    var field = container.closest('.fam-price-filter');
    if (!field) return;
    var numberMin = field.querySelector('[data-fam-number-min]');
    var numberMax = field.querySelector('[data-fam-number-max]');
    var countEl = field.querySelector('[data-fam-price-count]');
    var sectionId = container.dataset.sectionId;
    var max = parseFloat(rangeMin.max) || 1;
    var countTimer = null;

    function updateFill() {
      var minVal = parseFloat(rangeMin.value) || 0;
      var maxVal = parseFloat(rangeMax.value) || max;
      var minPct = (minVal / max) * 100;
      var maxPct = (maxVal / max) * 100;
      fill.style.left = minPct + '%';
      fill.style.width = Math.max(0, maxPct - minPct) + '%';
    }

    function updateLiveCount() {
      if (!countEl || !sectionId || !form) return;
      clearTimeout(countTimer);
      countTimer = setTimeout(function () {
        var params = new URLSearchParams(new FormData(form));
        params.set(numberMin.name, numberMin.value);
        params.set(numberMax.name, numberMax.value);
        params.set('section_id', sectionId);
        fetch(form.action + '?' + params.toString())
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newCount = doc.querySelector('.fam-result-count');
            if (newCount) countEl.textContent = newCount.textContent;
          })
          .catch(function () {});
      }, 350);
    }

    rangeMin.addEventListener('input', function () {
      if (parseFloat(rangeMin.value) > parseFloat(rangeMax.value)) {
        rangeMin.value = rangeMax.value;
      }
      numberMin.value = rangeMin.value;
      updateFill();
      updateLiveCount();
    });
    rangeMax.addEventListener('input', function () {
      if (parseFloat(rangeMax.value) < parseFloat(rangeMin.value)) {
        rangeMax.value = rangeMin.value;
      }
      numberMax.value = rangeMax.value;
      updateFill();
      updateLiveCount();
    });
    numberMin.addEventListener('input', function () {
      var v = parseFloat(numberMin.value);
      if (isNaN(v)) v = 0;
      rangeMin.value = v;
      updateFill();
      updateLiveCount();
    });
    numberMax.addEventListener('input', function () {
      var v = parseFloat(numberMax.value);
      if (isNaN(v)) v = max;
      rangeMax.value = v;
      updateFill();
      updateLiveCount();
    });
    updateFill();
  });

  if (form) {
    form.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
  }
});
